import {toBindingUrl} from './mappers/toBindingUrl'
import {toBoundedPaymentCard} from './mappers/toBoundedPaymentCard'
import {toCards} from './mappers/toCards'
import {toPaymentCard} from './mappers/toPaymentCard'
import type {CreatePaymentCardService, FetchCards} from './types'

export const createPaymentCardService: CreatePaymentCardService = function createPaymentService(params) {
  const {
    config: {
      country, //
      trustDomain,
    },
    cargoCorpRepository: {
      fetchEmployeeCardToBoundList, //
      fetchCardList,
      fetchCardBoundContext,
    },
    dcaaRepository: {fetchCardDetails},
  } = params
  const countryParams = country ? {country} : undefined
  const fetchCards: FetchCards = function fetchPaymentCards() {
    return fetchEmployeeCardToBoundList(countryParams).then(toCards)
  }

  return {
    fetchCards,
    async fetchBoundedCard() {
      const [paymentCards, boundedPaymentCardID] = await Promise.all([
        fetchCards(),
        fetchCardList({scopes: [{kind: 'agent_scheme'}]}, countryParams).then(toBoundedPaymentCard),
      ])

      return paymentCards.length > 0 && boundedPaymentCardID
        ? paymentCards.find(c => c.id === boundedPaymentCardID)
        : undefined
    },
    fetchBindingUrl() {
      return fetchCardBoundContext(
        {
          trust_domain: trustDomain,
          card_scope: {kind: 'agent_scheme'},
        },
        countryParams,
      ).then(toBindingUrl)
    },
    async fetchPaymentCardDetails(paymentMethodId) {
      const response = await fetchCardDetails({
        payment_method_id: paymentMethodId,
      })
      return toPaymentCard(response)
    },
  }
}
